import React from 'react';

import { useAuthContext } from 'src/auth/hooks';
import { Loading } from '../components/Loading';
import FirebaseLoginView from '../views/FirebaseLogin';

export function Login() {
  const { isLoading } = useAuthContext();
  
  if (isLoading) {
    return <Loading />;
  }

  return (
    <FirebaseLoginView />
  );
}
